import { Autocomplete, Button, Grid, TextField } from '@mui/material';
import React, { useState } from 'react'
import toast from 'react-hot-toast';
import { updateWinner } from '../AdminMenusRequests';

export const AddWinner = ({close,listOfGroups,setListOfGames,selectedGame,updateScoreBoard}) => {
    const [winner,setWinner] = useState(null)
    const handleSave = async (e) => {
        e.preventDefault();
        if(winner){
            const toastId = toast.loading('Updating winner'); 
            let t_data = {
                winner:winner,
                game_info:selectedGame
            }
            const res  = await updateWinner(t_data);
            if(res.data.status === 200){
                setListOfGames(res.data.data)
                updateScoreBoard()
                close();
                toast.success(res.data.message,{
                    id:toastId
                });
            }else{
                toast.error(res.data.message,{
                    id:toastId
                });
            }
        }else{
            toast.error('Oops... Please select a winner !',{
                duration:3000
            })
        }
        
    }
    return (
        <form onSubmit={handleSave}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Autocomplete
                    disablePortal
                    id={"combo-box-groups"}
                    options={listOfGroups}
                    getOptionLabel={(option) => `${option.group_name}`}
                    // sx={{ width: 300}}
                    fullWidth
                    value = {winner}
                    onChange={(event, newValue) => {
                        setWinner(newValue);
                        }}
                    renderInput={(params) => <TextField {...params} label="Winner" />}
                />
            </Grid>
            <Grid item xs={12} sx={{display:'flex',gap:1,justifyContent:'flex-end'}}>
                <Button variant='outlined' color='error' onClick={close}>
                    Cancel
                </Button>
                <Button variant='contained' color='success' type='submit'>
                    Save
                </Button>
            </Grid>
        </Grid>
        </form>
    )
}